(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDeleteController',WarningDeleteController);

    WarningDeleteController.$inject = ['$uibModalInstance', 'entity', 'Warning'];

    function WarningDeleteController($uibModalInstance, entity, Warning) {
        var vm = this;
        vm.warning = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Warning.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
